import '@/assets/scss/base/index.scss'
import '@/plugins/index'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import store from '@/store/index'

Vue.config.productionTip = false

const vue = new Vue({
  render: h => h(App),
  store: new Vuex.Store(store)
}).$mount('#app')

vue.$on('share_network_open', (network) => {
  vue.$metrics.pushEvent({
    'vk': vue.$metrics.events.CLICK_SHARE_VK,
    'facebook': vue.$metrics.events.CLICK_SHARE_FACEBOOK,
    'twitter': vue.$metrics.events.CLICK_SHARE_TWITTER,
    'telegram': vue.$metrics.events.CLICK_SHARE_TELEGRAM,
  }[network])
})
